/* tslint:disable */
/* eslint-disable */

import * as FirstCloudCommonTypes from "first-cloud-common/javaTypes";
import * as FirstCommonTypes from "first-common/javaTypes";

export interface GetRolesData {
    userRoles: UserRoleInfo[];
    applicableRoles: RoleInfo[];
}

export interface Season extends TardisSeasonId {
    seasonId: string;
    program: FirstCommonTypes.Program;
    cmpYear: number;
    startYear: number;
    yearString: string;
    gameName: string;
    logoUpload?: UploadReference;
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
}

export interface Answer {
    answerId: string;
    questionId: string;
    content: string;
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
    createdBy: string;
    modifiedBy: string;
}

export interface AnswerDraft {
    draftId: string;
    questionId: string;
    derivativeOf: string;
    number: number;
    content: string;
    staffVotes: number;
    answererVotes: number;
    state: DraftState;
    author: UserAccount;
    authorId: string;
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
}

export interface AnswererComment extends Comment {
    questionId: string;
}

export interface Board extends PathParamProvider {
    boardId: string;
    seasonId: string;
    season: Season;
    name: string;
    slug: string;
    config: BoardConfig;
    state: BoardState;
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
}

export interface CannedAnswer {
    canId: string;
    boardId: string;
    label: string;
    content: string;
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
    createdBy: string;
    modifiedBy: string;
}

export interface Comment {
    commentId: string;
    content: string;
    deleted: boolean;
    authorId: string;
    author: UserAccount;
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
}

export interface ContributionInfo {
    questionId: string;
    drafts: number;
    comments: number;
    draftComments: number;
    lastContributorId: string;
    lastContributor: UserAccount;
    lastUpdate: DateAsNumber;
}

export interface CustomTopic {
    topicId: string;
    boardId: string;
    label: string;
    name: string;
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
    createdBy: string;
    modifiedBy: string;
}

export interface DraftComment extends Comment {
    draftId: string;
}

export interface Endorsement {
    draftId: string;
    userAccountId: string;
    createdAt: DateAsNumber;
    user: UserAccount;
    isAdmin: boolean;
    isGK: boolean;
}

export interface EndorsementStatus {
    questionId: string;
    draftId: string;
    adminCount: number;
    gkCount: number;
    answererCount: number;
}

export interface Question {
    questionId: string;
    boardId: string;
    number: number;
    status: QuestionStatus;
    title: string;
    content: string;
    followupToId: string;
    followupTo: Question;
    topic: string;
    rule: string;
    flaggedBy: string;
    flagger: UserAccount;
    flaggedAt: DateAsNumber;
    asker: string;
    askerAccount: UserAccount;
    askerTeamId: string;
    askerTeam: Team;
    rejectionComment: string;
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
    submittedAt: DateAsNumber;
    answer: Answer;
}

export interface QuestionLastSeen {
    questionId: string;
    userAccountId: string;
    lastSeen: DateAsNumber;
}

export interface QuestionTeamSearchResult {
    myTeams: TeamOption[];
    generalTeams: TeamOption[];
}

export interface QAUpload extends Upload {
    uploadId: string;
    uploadKey: UploadReference;
    filename: string;
    contentType: string;
    metadata: string;
    byteSize: number;
    checksum: string;
    isPublic: boolean;
    createdAt: DateAsNumber;
    modifiedAt: DateAsNumber;
}

export interface UploadReference {
}

export interface TardisSeasonId {
}

export interface UserAccount extends FirstCommonTypes.Serializable {
    userAccountId: string;
    email: string;
    firstName: string;
    lastName: string;
}

export interface BoardConfig {
    isPublic: boolean;
    volunteerRoles: string[];
    roleRequireAssignment: boolean;
    roleRequireCertification: boolean;
    questionLimitSoft: number;
    questionLimitHard: number;
    questionLimitSoftWarning: string;
    questionInstructions: string;
    viewUnanswered: boolean;
    autoAccept: boolean;
    enableFollowups: boolean;
    enableTopic: QuestionInputConfig;
    enableRule: QuestionInputConfig;
    hideFromAsker: boolean;
    sendEmailOnAnswer: boolean;
    enableRSS: boolean;
    closeSubmissions: boolean;
    adminVotesRequired: number;
    gkVotesRequired: number;
}

export interface PathParamProvider {
}

export interface Team {
    teamId: string;
    seasonId: string;
    externalId: number;
    number: string;
    longName: string;
    shortName: string;
    city: string;
    stateProv: string;
    country: string;
    deleted: boolean;
}

export interface Upload {
}

export interface UserRoleInfo {
    role: QaRole;
    userAccountId: string;
    displayName: string;
}

export interface RoleInfo {
    role: QaRole;
    description: string;
}

export interface TeamOption {
    value: string;
    label: string;
}

export type DateAsNumber = number;

export const enum QuestionInputConfig {
    DISABLED = "DISABLED",
    OPTIONAL = "OPTIONAL",
    NEED_ONE = "NEED_ONE",
    REQUIRED = "REQUIRED",
}

export const enum DraftState {
    SUBMITTED = "SUBMITTED",
    REJECTED = "REJECTED",
    WITHDRAWN = "WITHDRAWN",
    ACCEPTED = "ACCEPTED",
}

export const enum BoardState {
    HIDDEN = "HIDDEN",
    ACTIVE = "ACTIVE",
    ARCHIVE = "ARCHIVE",
}

export const enum QuestionStatus {
    DRAFT = "DRAFT",
    SUBMITTED = "SUBMITTED",
    ACCEPTED = "ACCEPTED",
    ANSWERED = "ANSWERED",
    REJECTED = "REJECTED",
    DISMISSED = "DISMISSED",
}

export const enum QaRole {
    GLOBAL_ADMIN = "GLOBAL_ADMIN",
    PROGRAM_ADMIN = "PROGRAM_ADMIN",
    BOARD_ADMIN = "BOARD_ADMIN",
    GLOBAL_KEY = "GLOBAL_KEY",
    ANSWERER = "ANSWERER",
    VOLUNTEER = "VOLUNTEER",
    TEAM_MEMBER = "TEAM_MEMBER",
    APPLIED_VOLUNTEER = "APPLIED_VOLUNTEER",
    ASSIGNED_VOLUNTEER = "ASSIGNED_VOLUNTEER",
    CERTIFIED_VOLUNTEER = "CERTIFIED_VOLUNTEER",
    ASSIGNED_CERTIFIED_VOLUNTEER = "ASSIGNED_CERTIFIED_VOLUNTEER",
}
